import {useMutation, useQueryClient} from '@tanstack/react-query'

import {createContract, updateContract} from './api'
import {contractKeys} from './keys'
import {ContractRequest} from './types'

export const useCreateContract = () => {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: (body: ContractRequest) => createContract(body),
    onSuccess: () => {
      qc.invalidateQueries({queryKey: contractKeys.all})
    },
  })
}

export const useUpdateContract = () => {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: ({id, body}: {id: string; body: ContractRequest}) => updateContract(body, id),
    onSuccess: () => {
      qc.invalidateQueries({queryKey: contractKeys.all})
    },
  })
}
